<template>
  <div style="display: contents">
    <tr v-for="(item, index) in tableRows" :key="item.archiveId">
      <td v-if="showCheckbox">
        <Checkbox
          :id="'dr-checkbox' + index"
          theme="light"
          :value="item.archiveId"
          v-model="selectedArchives"
          :data-test-id="`${dataTestId}__row-${item.archiveId}__checkbox`"
        />
      </td>
      <td
        class="text-left pointerCursor max-width-100 wrap-text"
        :data-test-id="`${dataTestId}__go-to-archive-details`"
        @click="navigateToDetails(item)"
      >
        <span
          v-if="item.source"
          class="font24 mr-2 mdi"
          :class="
            IconResolver(item.source.fileExtension || item.source.itemType)
          "
        ></span>
        <!-- File name + File extension -->
        <span class="clickable">
          {{ item.source.name || item.source.fileName
          }}{{ (item.source && item.source.fileExtension) || '' }}
        </span>
      </td>
      <td class="text-left" v-if="!isTeamsConnector">
        <span>{{
          FileSizeConverter(
            item.source && (item.source.size || item.source.fileSize)
          )
        }}</span>
      </td>
      <td class="text-left" v-if="!isTeamsConnector">
        <span>{{
          splitUnderscoreToCaptialise(splitCamelCase(item.source.sourceType))
        }}</span>
      </td>
      <td class="text-left">
        <vault-accessibleBy-list
          :accessibleBy="item.source.accessibleBy"
          :ownerIds="item.source.ownerIds"
        />
      </td>

      <td class="text-left">
        <span>
          {{ getFormatedDateAsPerTimeAndDate(item.source.createdOn) }}
        </span>
      </td>
      <td class="text-left">
        <span>{{
          getFormatedDateAsPerTimeAndDate(item.source.updatedOn)
        }}</span>
      </td>
      <td class="text-center" v-if="!isTeamsConnector">
        <span>{{ item.source.version || '' }}</span>
      </td>
    </tr>
  </div>
</template>
<script>
import FileSizeConverter from '@/helpers/FileSizeConverter';
import IconResolver from '@/helpers/IconResolver';
import Checkbox from '@/components/Common/Checkbox';
import {
  splitUnderscoreToCaptialise,
  splitCamelCase
} from '../../helpers/common';
const VaultAccessibleByList = () =>
  import('@/components/ArchiveSearch/VaultAccessibleByList');
export default {
  props: {
    tableRows: Array,
    selectedItems: Array,
    selectItem: Function,
    from: String,
    type: String,
    showCheckbox: Boolean,
    dataTestId: String
  },
  data() {
    return {
      FileSizeConverter,
      IconResolver,
      splitUnderscoreToCaptialise,
      splitCamelCase
    };
  },
  computed: {
    selectedArchives: {
      get() {
        return this.selectedItems;
      },
      set(archives) {
        this.selectItem(archives);
      }
    },
    isTeamsConnector() {
      return this.$route.params?.connectorType === 'TEAMS';
    }
  },
  components: { Checkbox, VaultAccessibleByList },

  methods: {
    navigateToDetails(item) {
      if (this.type === 'configuration') {
        // if user clicks on an archive to view it, will check if they have necessary permission based on whether onw org or child org is selected
        let hasPermission = false;
        if (this.isOwnOrgSelected()) {
          // can_view_organisation_toolbox_archives
          if (this.$can('view', 'organisation_toolbox_archives')) {
            hasPermission = true;
          }
        } else {
          // can_view_child_organisation_toolbox_archives
          if (this.$can('view', 'child_organisation_toolbox_archives')) {
            hasPermission = true;
          }
        }
        if (!hasPermission) {
          this.snackbar('error', this.$message.NO_PERMISSION);
          return;
        }
      }
      if (this.from === 'DISCOVERY') {
        return this.$emit('openInModal', true, item);
      }
      // Sending connector name in route to detect whether to show chat box or file content component under vault detail page
      const isOrgVault = this.$route.meta?.fromType === 'org-vault';
      const connectorName = this.connectorArchiveNameMap(item.source.sourceType)
        .title;
      const url = isOrgVault ? `connector/${connectorName}/` : '';
      const messageGroupId = item?.source?.itemId || '';
      this.$router.push(
        `${url}search/${item.archiveId}/${item.source.version}?archiveId=${item.archiveId}&messageGroupId=${messageGroupId}`
      );
    }
  }
};
</script>

<style scoped>
.max-width-100 {
  max-width: 100px;
}
</style>
